import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from "styled-components";
import AvailabilityForm from '../../Components/AvailabilityForm';

const Background = styled.div`
    background: #669965;
    background: var(--main-theme-gradient);
    padding:4em;
`;
const Row = styled.div`
    display:flex;
    justify-content:center;
    flex-wrap:wrap;
`;

const SubHeader = styled.h4`
    padding-top:1em;
    color: #FFF;
    font-size: 2em;
    font-family: Lato-Bold;
        @media (max-width: 800px) {
            text-align:center;
            font-size: 1.8em;
        }
`;

function Splash() {

    const mobileView = useMediaQuery({
        query: '(max-width: 575px)'
    })
    
    return (
        <Background>
            <Row>
                {!mobileView && <img style={{width: "30%"}} src="/images/motorhome/Motorhome-Web-Assets-05.png"/>}
                <img style={{width: (mobileView ? "100%" : "40%")}} src="/images/motorhome/Motorhome-Web-Assets-01.png"/>
            </Row>
            <Row>
                <div style={{width: (mobileView ? "100%" : "70%")}}>
                    <SubHeader>Check Availability</SubHeader>
                    <AvailabilityForm />
                </div>
            </Row>
        </Background>
    );
}
export default Splash;
